import { default as KeepInTouchForm } from "views/forms/KeepInTouch";

const KeepInTouch = () => (
	<section className="keep-in-touch">
		<div className="row gy-3 justify-content-center">
			<div className="col-12">
				<h2 className="h4 text-uppercase text-primary-300">
					<strong>let's keep in touch</strong>
				</h2>
				<p className="mb-0">
					<small>
						Sign up to our newsletter & stay updated with recent updates about features and services, as
						well as discounts and offers.
					</small>
				</p>
			</div>
			<div className="col-12">
				<KeepInTouchForm />
			</div>
		</div>
	</section>
);
export default KeepInTouch;
